var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivateUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7586 11.3793C10.6333 11.3793 9.53328 11.0456 8.59762 10.4204C7.66196 9.79524 6.9327 8.90664 6.50206 7.86699C6.07143 6.82734 5.95875 5.68334 6.17829 4.57966C6.39783 3.47597 6.93971 2.46218 7.73543 1.66646C8.53114 0.870751 9.54494 0.328864 10.6486 0.109328C11.7523 -0.110209 12.8963 0.00246525 13.936 0.433102C14.9756 0.863738 15.8642 1.593 16.4894 2.52865C17.1146 3.46431 17.4483 4.56435 17.4483 5.68966C17.4483 7.19865 16.8488 8.64583 15.7818 9.71285C14.7148 10.7799 13.2676 11.3793 11.7586 11.3793ZM11.7586 2.27586C11.0834 2.27586 10.4234 2.47608 9.86202 2.85119C9.30062 3.2263 8.86307 3.75947 8.60469 4.38325C8.3463 5.00704 8.2787 5.69344 8.41042 6.35565C8.54214 7.01787 8.86728 7.62614 9.3447 8.10357C9.82213 8.581 10.4304 8.90613 11.0926 9.03785C11.7548 9.16958 12.4412 9.10197 13.065 8.84359C13.6888 8.58521 14.222 8.14765 14.5971 7.58626C14.9722 7.02486 15.1724 6.36484 15.1724 5.68966C15.1724 4.78426 14.8127 3.91595 14.1725 3.27574C13.5323 2.63553 12.664 2.27586 11.7586 2.27586ZM22.3793 22C22.0787 21.9961 21.7916 21.8749 21.579 21.6624C21.3665 21.4498 21.2453 21.1626 21.2414 20.8621C21.2414 17.9034 19.6331 15.931 11.7586 15.931C3.88414 15.931 2.27586 17.9034 2.27586 20.8621C2.27586 21.1639 2.15597 21.4533 1.94257 21.6667C1.72917 21.8801 1.43973 22 1.13793 22C0.836133 22 0.546696 21.8801 0.333292 21.6667C0.119889 21.4533 0 21.1639 0 20.8621C0 13.6552 8.23862 13.6552 11.7586 13.6552C15.2786 13.6552 23.5172 13.6552 23.5172 20.8621C23.5133 21.1626 23.3922 21.4498 23.1796 21.6624C22.967 21.8749 22.6799 21.9961 22.3793 22Z",
    fill: "#4A4A4A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1677_477)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 11,
    height: 11,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12.1719C18.5574 12.1719 16.1719 14.5573 16.1719 17.5C16.1719 20.4426 18.5574 22.8281 21.5 22.8281C24.4426 22.8281 26.8281 20.4426 26.8281 17.5C26.8281 14.5574 24.4426 12.1719 21.5 12.1719ZM24.2953 14.7047C25.7014 16.1108 25.7992 18.26 24.7395 19.7672L19.2328 14.2605C20.741 13.2001 22.89 13.2994 24.2953 14.7047ZM18.7047 20.2953C17.2986 18.8892 17.2008 16.74 18.2605 15.2328L23.7672 20.7395C22.259 21.7999 20.11 21.7006 18.7047 20.2953Z",
    fill: "#4A4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1677_477"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 11,
    height: 11,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateUser);
export default __webpack_public_path__ + "static/media/deactivate-user.70692b9d3de92e03e5a7710c822f1c64.svg";
export { ForwardRef as ReactComponent };